var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.44,
    cy: 29.44,
    r: 29.44,
    fill: "#2544EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5915 35.1505H22.7846C21.2701 35.1505 19.8176 34.5489 18.7467 33.478C17.6758 32.4071 17.0742 30.9547 17.0742 29.4402C17.0742 27.9257 17.6758 26.4733 18.7467 25.4024C19.8176 24.3315 21.2701 23.7298 22.7846 23.7298H26.5915M32.3018 23.7298H36.1087C37.6232 23.7298 39.0756 24.3315 40.1465 25.4024C41.2174 26.4733 41.819 27.9257 41.819 29.4402C41.819 30.9547 41.2174 32.4071 40.1465 33.478C39.0756 34.5489 37.6232 35.1505 36.1087 35.1505H32.3018M23.932 29.4402H35.0802",
    stroke: "white",
    strokeWidth: 2.14138,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/linkIcon.f27048de9cb02966f8192a127da45213.svg";
export { ForwardRef as ReactComponent };